import Checked from '@/assets/icons/common/checked.svg';
import { cn } from '@/utils/cn';

interface SelectProps {
  id: string;
  children: React.ReactNode;
  isSelected: boolean;
  onSelect: (id: string) => void;
  className?: string;
  style?: React.CSSProperties;
}

export const Select = ({ id, children, isSelected, onSelect, className, style }: SelectProps) => {
  return (
    <div
      className={cn(
        'flex flex-row items-center justify-between px-3 h-13 flex-shrink-0 rounded-xl border-1 border-base-border w-full cursor-pointer',
        className
      )}
      style={style}
      onClick={() => onSelect(id)}
    >
      <div className="flex flex-row items-center w-full">{children}</div>
      <div className="flex flex-row items-center">
        {isSelected && <img src={Checked} alt="checked" className={isSelected ? 'opacity-100' : 'opacity-0'} />}
      </div>
    </div>
  );
};
